import { onSnapshot } from 'firebase/firestore';
import { startTransition } from 'react';
import { studentSubCol } from '../../firebase/config';

// Sunucuda orderBy kullanılmaz: timestamp alanı olmayan eski kayıtları sorgudan düşürür
const SUB_FIELDS = [
  { key: 'swimmingRecords', name: 'swimmingRecords', sortByTimestamp: true },
  { key: 'programs', name: 'programs', sortByTimestamp: false },
];

const byTimestampDesc = (a, b) => (Number(b.timestamp) || 0) - (Number(a.timestamp) || 0);

/**
 * Öğrenci alt koleksiyonları için tek abonelik noktası (SRP / DRY).
 * @returns {() => void} unsubscribe
 */
export function subscribeStudentSubData(studentId, setState, { onFirstLoad, label, onError } = {}) {
  const loadedKeys = new Set();

  const markLoaded = (key) => {
    if (!onFirstLoad) return;
    loadedKeys.add(key);
    if (loadedKeys.size >= SUB_FIELDS.length) {
      startTransition(() => {
        setState((prev) => ({ ...prev, isLoading: false }));
      });
    }
  };

  const unsubs = SUB_FIELDS.map(({ key, name, sortByTimestamp }) => onSnapshot(
    studentSubCol(studentId, name),
    (snap) => {
      const next = snap.docs.map((d) => ({ ...d.data(), id: d.id }));
      if (sortByTimestamp) next.sort(byTimestampDesc);
      startTransition(() => {
        setState((prev) => ({
          ...prev,
          [key]: next,
        }));
      });
      markLoaded(key);
    },
    (err) => {
      console.error(`${label || 'Öğrenci'} ${name} hatası:`, err);
      if (onError) onError(err, name);
      markLoaded(key);
    }
  ));

  return () => unsubs.forEach((u) => u());
}
